/* mm-preis-zaehler.js — Hauptpreis mit derselben Ziffernrolle wie das Abo.
 *
 * Nur die sichtbaren Ziffern des aktuellen Hauptpreises rollen. Komma,
 * Tausenderpunkt, Leerraum und Waehrungszeichen bleiben statisch. Der
 * durchgestrichene Vergleichspreis wird nie angefasst.
 *
 * Die echte .money-Zeichenkette bleibt waehrend der gesamten Animation im DOM
 * und wird nicht umgeschrieben. Eine aria-hidden Sichtkopie liegt fuer weniger
 * als eine Sekunde darueber; danach wird sie wieder entfernt. Die Ziffernrolle
 * startet direkt als CSS-Animation und endet selbst bei verzögerten JavaScript-
 * Timern sicher auf dem echten Preis statt auf 00,00. Dadurch lesen Preis-Apps
 * und Screenreader weiterhin exakt den Originalpreis.
 */
(function () {
  'use strict';

  var ZAHL = /\d/;
  var GELD = /\d{1,3}(?:\.\d{3})*,\d{2}/;
  var states = [];
  var lastAnimatedText = '';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function style() {
    if (document.getElementById('mm-preis-roll-style')) return;
    var node = document.createElement('style');
    node.id = 'mm-preis-roll-style';
    node.textContent = [
      '[data-mm-preis-roll]{position:relative!important}',
      '.mmPriceRollVisual+.money{opacity:0!important}',
      '.mmPriceRollVisual{position:absolute;z-index:1;left:0;top:0;height:100%;display:inline-flex;',
        'align-items:baseline;white-space:pre;pointer-events:none;color:currentColor;font:inherit;line-height:inherit}',
      '.mmPRStatic{display:inline-block;font:inherit;line-height:inherit}',
      '.mmPRDigit{display:inline-block;height:.9em;overflow:hidden;font:inherit;line-height:.9;',
        'vertical-align:baseline;font-variant-numeric:tabular-nums}',
      '.mmPRTrack{display:block;font:inherit;font-style:normal;line-height:.9;transform:translateY(0);',
        'will-change:transform;animation:mmPreisRollTrack .55s cubic-bezier(.22,.61,.36,1) var(--mmDelay) both}',
      '.mmPRTrack span{display:block;height:.9em;font:inherit;line-height:.9}',
      '@keyframes mmPreisRollTrack{from{transform:translateY(0)}to{transform:translateY(var(--mmShift))}}'
    ].join('');
    (document.head || document.documentElement).appendChild(node);
  }

  function digitNode(digit, charIndex) {
    var viewport = document.createElement('span');
    viewport.className = 'mmPRDigit';
    var track = document.createElement('span');
    track.className = 'mmPRTrack';
    track.style.setProperty('--mmShift', String(parseFloat((-Number(digit) * 0.9).toFixed(2))) + 'em');
    track.style.setProperty('--mmDelay', String(140 + (charIndex * 35)) + 'ms');
    for (var number = 0; number <= 9; number++) {
      var item = document.createElement('span');
      item.textContent = String(number);
      track.appendChild(item);
    }
    viewport.appendChild(track);
    return viewport;
  }

  function visualFor(text) {
    var visual = document.createElement('span');
    visual.className = 'mmPriceRollVisual';
    visual.setAttribute('aria-hidden', 'true');
    var chars = Array.from(text);
    for (var index = 0; index < chars.length; index++) {
      var char = chars[index];
      if (ZAHL.test(char)) {
        visual.appendChild(digitNode(char, index));
      } else {
        var fixed = document.createElement('span');
        fixed.className = 'mmPRStatic';
        fixed.textContent = char;
        visual.appendChild(fixed);
      }
    }
    return visual;
  }

  function clean(state, runId) {
    if (typeof runId === 'number' && state.runId !== runId) return;
    window.clearTimeout(state.finishTimer);
    if (state.visual && state.visual.parentNode) state.visual.parentNode.removeChild(state.visual);
    state.visual = null;
    state.host.classList.remove('mmPRActive');
  }

  function validPrice(text) {
    var match = String(text || '').match(GELD);
    if (!match) return false;
    return Number(match[0].replace(/\./g, '').replace(',', '.')) > 0;
  }

  function queuePlay(state) {
    window.clearTimeout(state.startTimer);
    clean(state);
    state.pending = true;
    if (!state.visible || document.hidden || !state.money.isConnected || !state.host.isConnected) return;
    state.startTimer = window.setTimeout(function () {
      state.startTimer = 0;
      play(state);
    }, 180);
  }

  function play(state) {
    if (!state.visible || document.hidden || !state.money.isConnected || !state.host.isConnected) {
      clean(state);
      state.pending = true;
      return;
    }
    var text = state.money.textContent || '';
    if (!validPrice(text)) {
      clean(state);
      state.pending = true;
      return;
    }

    if (text === lastAnimatedText) {
      clean(state);
      state.text = text;
      state.observedText = text;
      state.pending = false;
      return;
    }

    clean(state);
    state.text = text;
    state.observedText = text;
    state.pending = false;
    lastAnimatedText = text;
    state.runId += 1;
    var runId = state.runId;
    state.visual = visualFor(text);
    state.host.insertBefore(state.visual, state.money);
    state.host.classList.add('mmPRActive');
    state.finishTimer = window.setTimeout(function () {
      clean(state, runId);
    }, 900 + (text.length * 35));
  }

  function watch(host, money) {
    if (host._mmPreisRollState && host._mmPreisRollState.money === money) return;
    if (host._mmPreisRollState) {
      if (host._mmPreisRollState.mutation) host._mmPreisRollState.mutation.disconnect();
      if (host._mmPreisRollState.intersection) host._mmPreisRollState.intersection.disconnect();
      window.clearTimeout(host._mmPreisRollState.startTimer);
      clean(host._mmPreisRollState);
    }

    host.dataset.mmPreisRoll = '1';
    var state = {
      host: host,
      money: money,
      text: money.textContent || '',
      observedText: money.textContent || '',
      visible: false,
      pending: true,
      visual: null,
      startTimer: 0,
      finishTimer: 0,
      runId: 0,
      mutation: null,
      intersection: null
    };
    host._mmPreisRollState = state;
    states.push(state);

    state.mutation = new MutationObserver(function () {
      var next = money.textContent || '';
      if (next === state.observedText) return;
      state.observedText = next;
      if (next === state.text) {
        window.clearTimeout(state.startTimer);
        clean(state);
        state.pending = false;
        return;
      }
      queuePlay(state);
    });
    state.mutation.observe(money, { childList: true, characterData: true, subtree: true });

    if ('IntersectionObserver' in window) {
      state.intersection = new IntersectionObserver(function (entries) {
        state.visible = entries[0].isIntersecting;
        if (!state.visible) {
          window.clearTimeout(state.startTimer);
          clean(state);
        }
        if (state.visible && state.pending) queuePlay(state);
      }, { threshold: 0.6 });
      state.intersection.observe(host);
    } else {
      state.visible = true;
      queuePlay(state);
    }
  }

  function anmelden() {
    var preise = document.querySelectorAll(
      '[id^="ProductInformation-"] product-price .price-item__group.price'
    );
    for (var index = 0; index < preise.length; index++) {
      var host = preise[index];
      if (String(host.className).indexOf('compare-at') > -1) continue;
      var money = host.querySelector(':scope > .money');
      if (!money || !GELD.test(money.textContent || '')) continue;
      watch(host, money);
    }
    return preise.length > 0;
  }

  function start() {
    if (!/\/products\//.test(window.location.pathname)) return;
    style();
    anmelden();
    var target = document.querySelector('[id^="ProductInformation-"]') || document.body;
    var refreshTimer = 0;
    new MutationObserver(function () {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(anmelden, 80);
    }).observe(target, { childList: true, subtree: true });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      for (var hiddenIndex = 0; hiddenIndex < states.length; hiddenIndex++) {
        window.clearTimeout(states[hiddenIndex].startTimer);
        clean(states[hiddenIndex]);
      }
      return;
    }
    for (var index = 0; index < states.length; index++) {
      if (states[index].visible && states[index].pending) queuePlay(states[index]);
    }
  });

  window.addEventListener('pagehide', function () {
    for (var index = 0; index < states.length; index++) {
      window.clearTimeout(states[index].startTimer);
      clean(states[index]);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
